import { render, staticRenderFns } from "./ElderlyDetails.vue?vue&type=template&id=286ab141&scoped=true&"
import script from "./ElderlyDetails.vue?vue&type=script&lang=js&"
export * from "./ElderlyDetails.vue?vue&type=script&lang=js&"
import style0 from "./ElderlyDetails.vue?vue&type=style&index=0&id=286ab141&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286ab141",
  null
  
)

export default component.exports